import NotFound from '@/components/error-pages/NotFound';
import React from 'react';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router';
import AuthRoute from '../AuthRoute';
import ExternalLinkMeetings from './ExternalLinkMeetings';
import ExternalLinkRejectedTasksRouting from './ExternalLinkTasksRouting';
import ExternalLinksRoutingChangeRequest from './ExternalLinksRoutingChangeRequest';
import ExternalLinksRoutingChangeRequestOffer from './ExternalLinksRoutingChangeRequestOffer';
import ExternalRoutingChat from './ExternalLinksRoutingChat';

type ExternalLinksRoutingProps = RouteComponentProps<any> & {};

const ExternalLinksRouting: React.FC<ExternalLinksRoutingProps> = ({ match }) => {
    var baseUrl = match ? match.url : '/';
    return (
        <Switch>
            <AuthRoute exact path={`${baseUrl}/chat/:threadId`} component={ExternalRoutingChat} />
            <AuthRoute
                exact
                path={`${baseUrl}/change-request/:changeRequestId`}
                component={ExternalLinksRoutingChangeRequest}
            />
            <AuthRoute
                exact
                path={`${baseUrl}/change-request/:changeRequestId/offer`}
                component={ExternalLinksRoutingChangeRequestOffer}
            />
            <AuthRoute
                exact
                path={`${baseUrl}/tasks/:type(project-documents|documents|external-agreements|buyer-options)/rejected/:objectId?`}
                component={ExternalLinkRejectedTasksRouting}
            />
            <AuthRoute
                exact
                path={`${baseUrl}/book-meeting/:projectId`}
                component={ExternalLinkMeetings}
            />

            <Route component={NotFound} />
        </Switch>
    );
};

export default withRouter(ExternalLinksRouting);
